import classes from "./DeleteCustomerAddress.module.css";
import ModalWrapper from "../modalWrapper/ModalWrapper";
import { ActionBtn } from "../buttons/actionBtn/ActionBtn";
import { useLocation } from "react-router-dom";
import { LoadingSpinner } from "../loadingSpinner/LoadingSpinner";
import { deleteCustomer } from "../../redux/customer/thunks/deleteCustomerThunk";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { deleteDepartment } from "../../redux/department/thunks/deleteDepartmentThunk";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetDeleteCustomerStatus } from "../../redux/customer/slices/deleteCustomerSlice";
import { resetDeleteDepartmentStatus } from "../../redux/department/slices/deleteDepartmentSlice";
import {
  deleteCustomerDraft,
  resetDeleteCustomerDraftState,
} from "../../redux/integrations/deleteCustomerDraft";
import {
  toggleDeleteCustomerAddressModal,
  setErrorMsg,
  onErrorMessage,
  setSuccessMsg,
  onDeleteConfirm,
  setIsDeleteConfirmShown,
  setIsModalsBgShown,
  setIsErrorMsg,
} from "../../redux/globalFunctions/globalFnSlice";

export function DeleteCustomerAddress() {
  const { selectedDataForEdit, isCustomerActive } = useSelector(
    (state) => state.global
  );
  const deleteCustomerState = useSelector((state) => state.deleteCustomer);
  const deleteDepartmentState = useSelector((state) => state.deleteDepartment);
  const { status } = useSelector((state) => state.deleteCustomerDraft);

  const dispatch = useDispatch();
  const hasMounted = useRef(false);
  const { t } = useTranslations();
  const location = useLocation();

  useEffect(() => {
    hasMounted.current = true;
  }, []);

  const handleDeleteCustomer = () => {
    if (location.pathname === "/integrations") {
      dispatch(
        deleteCustomerDraft({ customer_id: selectedDataForEdit.dc_custom_id })
      );
    } else {
      dispatch(
        deleteCustomer({
          customer_id: selectedDataForEdit.c_id,
        })
      );
    }
  };

  const handleDeleteLaundry = () => {
    dispatch(deleteDepartment({ department_id: selectedDataForEdit.d_id }));
  };

  const handleDelete = () => {
    if (isCustomerActive) {
      handleDeleteCustomer();
    } else {
      handleDeleteLaundry();
    }
  };

  useEffect(() => {
    // Handler for deleteCustomer statuses
    if (hasMounted.current) {
      if (deleteCustomerState.status === "success" || status === "success") {
        dispatch(toggleDeleteCustomerAddressModal());
        dispatch(
          setSuccessMsg(deleteCustomerState.message || "Successfully deleted")
        );
        dispatch(onDeleteConfirm());
        setTimeout(() => {
          dispatch(setIsDeleteConfirmShown(false));
          dispatch(setIsModalsBgShown(false));
          dispatch(resetDeleteCustomerStatus());
          dispatch(resetDeleteCustomerDraftState());
        }, 1500);
      } else if (deleteCustomerState.status === "error" || status === "error") {
        dispatch(toggleDeleteCustomerAddressModal());
        dispatch(setErrorMsg(deleteCustomerState.error));
        dispatch(onErrorMessage());
        setTimeout(() => {
          dispatch(setIsDeleteConfirmShown(false));
          dispatch(setIsModalsBgShown(false));
          dispatch(setIsErrorMsg(false));
          dispatch(setErrorMsg(""));
          dispatch(resetDeleteCustomerStatus());
          dispatch(resetDeleteCustomerDraftState());
        }, 1500);
      }
    }
  }, [deleteCustomerState.status, dispatch, status]);

  // Handler for deleteDepartment statuses
  useEffect(() => {
    if (hasMounted.current) {
      if (deleteDepartmentState.status === "success") {
        dispatch(toggleDeleteCustomerAddressModal());
        dispatch(setSuccessMsg(deleteDepartmentState.message));
        dispatch(onDeleteConfirm());
        setTimeout(() => {
          dispatch(setIsDeleteConfirmShown(false));
          dispatch(setIsModalsBgShown(false));
          dispatch(resetDeleteDepartmentStatus());
        }, 1500);
      } else if (deleteDepartmentState.status === "error") {
        dispatch(toggleDeleteCustomerAddressModal());
        dispatch(setErrorMsg(deleteDepartmentState.error));
        dispatch(onErrorMessage());
        setTimeout(() => {
          dispatch(setIsDeleteConfirmShown(false));
          dispatch(setIsModalsBgShown(false));
          dispatch(setIsErrorMsg(false));
          dispatch(setErrorMsg(""));
          dispatch(resetDeleteDepartmentStatus());
        }, 1500);
      }
    }
  }, [deleteDepartmentState.status, dispatch]);

  const isStatusLoading =
    deleteCustomerState.status === "loading" ||
    deleteDepartmentState.status === "loading" ||
    status === "loading";

  const modalText = t.deleteModal;

  const headerText = isCustomerActive
    ? modalText.deleteCustomer.headerText
    : modalText.deleteLaundry.headerText;

  const warningText = isCustomerActive
    ? modalText.deleteCustomer.warningText
    : modalText.deleteLaundry.warningText;

  return (
    <ModalWrapper
      onClick={() => dispatch(toggleDeleteCustomerAddressModal())}
      title={headerText}
      onSubmit={handleDelete}
    >
      <div>
        {modalText.deleteConfirmationText}{" "}
        <span className={classes.addressText}>
          {isCustomerActive
            ? selectedDataForEdit.c_address || selectedDataForEdit.dc_address
            : selectedDataForEdit.d_name}
        </span>
      </div>
      <div>{warningText}</div>
      <div className={classes.buttons}>
        <ActionBtn
          btnType="cancel"
          onClick={() => dispatch(toggleDeleteCustomerAddressModal())}
          text={modalText.cancel}
        />
        <ActionBtn
          disabled={isStatusLoading}
          onClick={handleDelete}
          text={isStatusLoading ? <LoadingSpinner /> : modalText.confirm}
        />
      </div>
    </ModalWrapper>
  );
}
